import { getAccessTokenFromCookie } from "../util/authentication";
import {
  REPORT_API_GENERATE_TRADE_DAILY_REPORT,
  REPORT_API_GENERATE_TRADE_DETAIL_REPORT,
  REPORT_API_GENERATE_TOR_REPORT,
  REPORT_API_GENERATE_TOR_DETAIL_REPORT,
  REPORT_API_GENERATE_TAED_CONFLICT_REPORT,
  REPORT_API_GENERATE_PERMANENT_BID_REPORT,
} from "../util/constants";

import { REPORT_DOWNLOAD_ENDPOINTS } from "../util/specialUserConstants";

export const generateTradeDetailReport = async (payload) => {
  const apiEndpoint = process.env.REACT_APP_REPORT_API + REPORT_API_GENERATE_TRADE_DETAIL_REPORT;

  const response = await fetch(apiEndpoint, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
    },
    body: payload,
  });

  if (!response.ok) {
    throw Error(`GET ${apiEndpoint} API Call failed.`, response);
  }
  return response;
};

export const generateTradeDailyReport = async (payload) => {
  const apiEndpoint =
    process.env.REACT_APP_REPORT_API +
    REPORT_API_GENERATE_TRADE_DAILY_REPORT +
    `/${payload?.station}` +
    `/${payload?.shiftDate}` +
    `/${payload?.eid}`;

  const response = await fetch(apiEndpoint, {
    headers: {
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
    },
  });

  if (!response.ok) {
    throw Error(`GET ${apiEndpoint} API Call failed.`, response);
  }
  return response;
};
export const generateTORReport = async (payload) => {
  const apiEndpoint =
    process.env.REACT_APP_REPORT_API +
    REPORT_API_GENERATE_TOR_REPORT +
    `/${payload?.station}` +
    `/${payload?.shiftDate}` +
    `/${payload?.eid}`;
  const response = await fetch(apiEndpoint, {
    headers: {
      "Content-Type": "application/json",

      authorization: "Bearer " + getAccessTokenFromCookie(),
    },
  });

  if (!response.ok) {
    throw Error(`GET ${apiEndpoint} API Call failed.`, response);
  }
  console.log(response, "response");
  return response;
};

export const generateTORDetailReport = async (payload) => {
  const apiEndpoint = process.env.REACT_APP_REPORT_API + REPORT_API_GENERATE_TOR_DETAIL_REPORT;

  const response = await fetch(apiEndpoint, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
    },
    body: payload,
  });

  if (!response.ok) {
    throw Error(`GET ${apiEndpoint} API Call failed.`, response);
  }
  return response;
};

export const generateConflictReport = async (payload) => {
  const apiEndpoint =
    process.env.REACT_APP_REPORT_API +
    REPORT_API_GENERATE_TAED_CONFLICT_REPORT +
    `/${payload?.station}` +
    `/${payload?.startDate}` +
    `/${payload?.endDate}`;

  const response = await fetch(apiEndpoint, {
    headers: {
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
    },
  });

  if (!response.ok) {
    throw Error(`GET ${apiEndpoint} API Call failed.`, response);
  }
  return response;
};

export const generatePermanentBidReport = async (payload) => {
  const apiEndpoint =
    process.env.REACT_APP_REPORT_API +
    REPORT_API_GENERATE_PERMANENT_BID_REPORT +
    `/${payload?.station}` +
    `/${payload.workgroup.join(",")}`;

  const response = await fetch(apiEndpoint, {
    headers: {
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
    },
  });

  if (!response.ok) {
    throw Error(`GET ${apiEndpoint} API Call failed.`, response);
  }
  return response;
};

export const generateReport = async (reportType) => {
  const apiEndpoint = REPORT_DOWNLOAD_ENDPOINTS[reportType];
  console.log("api: ", apiEndpoint);
  const response = await fetch(apiEndpoint, {
    headers: {
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
    },
  });

  if (!response.ok) {
    throw Error(`GET ${apiEndpoint} API Call failed.`, response);
  }
  return response;
};
